import React, { useEffect, useRef, useState } from "react";
import KidsModal from "../ModalVideo/KidsModal";
import { fetchCategories, fetchGallery, resolveMediaUrl } from "../../api/galleryApi";

const ALL_VIDEOS_TAB = "All Videos";
/** Must stay ≤ backend galleryRepo MAX_LIST_LIMIT */
const VIDEO_PAGE_LIMIT = 500;

function GalleryVideos() {
  const [videoTabs, setVideoTabs] = useState([ALL_VIDEOS_TAB]);
  const [toggleVideo, setToggleVideo] = useState(ALL_VIDEOS_TAB);
  const [GalleryData, setGalleryData] = useState([]);
  const [CategoryName, setCategoryName] = useState(ALL_VIDEOS_TAB);
  /** Bumps when the tab becomes visible again so lists match admin after deletes in another tab. */
  const [visibilityRefresh, setVisibilityRefresh] = useState(0);
  const fetchGenRef = useRef(0);

  const toggleTab = (tab) => {
    setToggleVideo(tab);
    setCategoryName(tab);
  };

  useEffect(() => {
    let mounted = true;
    (async () => {
      const data = await fetchCategories();
      const vc = data.videoCategories || [];
      const tabs = [ALL_VIDEOS_TAB, ...vc];
      if (!mounted) return;
      setVideoTabs(tabs);
    })().catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") {
        setVisibilityRefresh((n) => n + 1);
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);

  useEffect(() => {
    const gen = ++fetchGenRef.current;
    let mounted = true;
    (async () => {
      try {
        const res = await fetchGallery({
          type: "video",
          category: CategoryName === ALL_VIDEOS_TAB ? undefined : CategoryName,
          page: 1,
          limit: VIDEO_PAGE_LIMIT,
        });
        if (!mounted || gen !== fetchGenRef.current) return;
        setGalleryData(res.items || []);
      } catch (e) {
        if (!mounted || gen !== fetchGenRef.current) return;
        console.error("GalleryVideos: failed to load videos", e);
        setGalleryData([]);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [CategoryName, visibilityRefresh]);

  return (
    <div className="mt-8">
      <div className="flex flex-wrap justify-center flex-grow gap-7">
        {videoTabs.map((items) => (
          <div key={items}>
            <button
              className={
                toggleVideo === items
                  ? "relative block bg-none text-[#45b3df] text-2xl font-extrabold after:absolute after:left-0 after:bottom-[-12px] after:bg-[#45b3df] after:h-1 after:w-full"
                  : "relative block font-bold bg-none text-[#fa9db7] text-2xl"
              }
              onClick={() => toggleTab(items)}
            >
              {items}
            </button>
          </div>
        ))}
      </div>
      <div>
        <div className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-5 pt-12">
          {GalleryData.map((videosItem) => (
            <div className="relative text-center" key={videosItem.id}>
              <img
                src={resolveMediaUrl(videosItem.thumbnail_url)}
                className="rounded-lg h-40 w-full lg:h-60 md:h-60"
                alt=""
              />
              <KidsModal VideoModalVideos={videosItem.youtube_url} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GalleryVideos;
